export const EARNING_RULE_TYPES = {
  ORDER: '0',
  AMOUNT: '1',
  REFERRAL: '2',
  SIGN_UP: '3',
  ITEM_PURCHASED: '4',
};

export const PROMOTION_RULE_TYPES = {
  ORDER: '0',
  AMOUNT: '1',
  REFERRAL: '2',
  SIGN_UP: '3',
  ITEM_PURCHASED: '4',
};

export const REDEMPTION_RULE_TYPES = {
  ORDER: '0',
  AMOUNT: '1',
  REFERRAL: '2',
  SIGN_UP: '3',
  ITEM_PURCHASED: '4',
};

// Default values for loyalty components
export const LOYALTY_DEFAULTS = {
  POINTS_TERMINOLOGY: 'points',
  CURRENCY_SYMBOL: '$',
  LEVEL: 0,
};
